import React, { useState, useEffect } from "react";
import Loader from "../../components/molecules/Loader";
import PreviewImg from "../../assets/search.png";
import ExecelImg from "../../assets/excel.png";
import FilePreview from "./FilePreview";
import { read, utils } from "xlsx";
import { IBulkRegRequest } from "../../typings/interfaces/Requests/BulkRegRequest";
import { SaveBulkRegistration } from "../../api/apimethods";
import { useNavigate } from "react-router-dom";
import { AppContext, defaultAppContextData } from "../../services/appData";
import { useAuthService, useContextService } from "../../services";

interface UploadedFile {
  name: string;
  date: string;
  file: File;
}

interface UploadFileListProps {
  uploadedFiles: UploadedFile[];
  registrationType: any;
  bulkRequestedData: IBulkRegRequest;
  inputData: any;
}

const UploadFileList: React.FC<UploadFileListProps> = ({
  uploadedFiles,
  registrationType,
  bulkRequestedData,
  inputData,
}) => {
  const { getContextValueFromStorage } = useContextService();
  const [contextData] = useState(() =>
    getContextValueFromStorage(defaultAppContextData)
  );
  const user = contextData.user;

  const [errorMessage, setErrorMessage] = useState("");
  const [selectedFile, setSelectedFile] = useState<UploadedFile | null>(null);
  const [excelData, setExcelData] = useState<any[][]>([]);
  const [columnsToExtract, setColumnsToExtract] = useState<number[]>([]);
  const [uploadFileError, setUploadFileError] = useState(false);
  const [invalidFileError, setInvalidFileError] = useState(false);
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [isSubmiting, setSubmiting] = useState(false);
  let navigate = useNavigate();
  const fixTimezoneOffset = (date: Date | null): Date | null => {
    if (!date) return null;
    return new Date(date.getTime() - date.getTimezoneOffset() * 60000);
  };

  useEffect(() => {
    const type = registrationType.RegistrationType;
    if (registrationType === "DragonFish" || type === "DragonFish") {
      registrationType = "DragonFish";
      setColumnsToExtract([0, 1, 2]);
    } else if (registrationType === "Crocodile" || type === "Crocodile") {
      registrationType = "Crocodile";
      setColumnsToExtract([0]);
    } else {
      registrationType = "Bird";
      setColumnsToExtract([0,1,2]);
    }
  }, [registrationType]);

  const handleFileSelect = (uploadedFile: UploadedFile) => {
    const reader = new FileReader();
    reader.onload = null;
    reader.onload = (e) => {
      if (e.target) {
        const data = new Uint8Array(e.target.result as ArrayBuffer);
        const workbook = read(data, { type: "array" });
        const worksheet = workbook.Sheets[workbook.SheetNames[0]];
        const excelData: any[][] = utils.sheet_to_json(worksheet, {
          header: 1,
        });
        setExcelData(excelData);
        setSelectedFile(uploadedFile);
      }
    };
    reader.readAsArrayBuffer(uploadedFile.file);
    reader.onerror = function (error) {};
  };

  const handleFormSubmit = async () => {
    if (!uploadedFiles || uploadedFiles.length === 0) {
      return;
    }
    let processedFilesCount = 0;
    const bulkRegRequests: IBulkRegRequest[] = [];

    const handleFileProcessed = (bulkRegRequest: IBulkRegRequest[]) => {
      processedFilesCount++;
      bulkRegRequest.forEach((element) => {
        bulkRegRequests.push(element);
      });

      if (processedFilesCount === uploadedFiles.length) {
        // All files have been processed
        makeApiCall();
      }
    };

    const makeApiCall = async () => {
      try {
        setSubmiting(true);
        setDisableSubmit(true);
        // Make the API call using the bulkRegRequests array
        const response = await SaveBulkRegistration(bulkRegRequests);
        if (response.data.data) {
          setSubmiting(false);
          setDisableSubmit(false);
          var sSourceofFish = inputData.data.sSourceofFish;
          let path = `/Single-Reg-Complete`;
          navigate(path, { state: { registrationType, sSourceofFish } });
        } else {
          setSubmiting(false);
          setDisableSubmit(false);
          const errorMessage = response.data.message;
          setErrorMessage(errorMessage);
        }
      } catch (error) {
        console.error("API Error:", error);
      }
    };

    const varietyOfFishArray = [
      { id: 1, text: "Red" },
      { id: 2, text: "Gold" },
      { id: 3, text: "Green" },
      // Add more objects with text properties as needed
    ];

    const lengthOfFishArray = [
      { id: 1, text: "12-15 cm" },
      { id: 2, text: "16-20 cm" },
      { id: 3, text: "More than 20cm" },
      // Add more objects with text properties as needed
    ];

    const arrayBufferToBase64 = (buffer: ArrayBuffer | Uint8Array) => {
      let binary = "";
      const bytes = buffer instanceof Uint8Array ? buffer : new Uint8Array(buffer);
      const len = bytes.byteLength;
      for (let i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i]);
      }
      return window.btoa(binary);
    };

    uploadedFiles.forEach((uploadedFile) => {
      // const bufferReader = new FileReader();
      // const base64data = bufferReader.result;

      const reader = new FileReader();
      // reader.readAsDataURL(uploadedFile.file);

      reader.onload = (e) => {
        if (e.target) {
          const data = new Uint8Array(e.target.result as ArrayBuffer);
          const base64data = arrayBufferToBase64(data);
          const uploadedDocument = {
            fileName: uploadedFile.name,
            file: base64data,
          };
          const workbook = read(data, { type: "array" });
          const worksheet = workbook.Sheets[workbook.SheetNames[0]];
          const excelData: any[][] = utils.sheet_to_json(worksheet, {
            header: 1,
          });
          const fileBulkRegRequests: IBulkRegRequest[] = [];
          if (excelData.length <= 1) {
            setUploadFileError(true);

            return;
          }
          if (excelData.length > 1) {
            let columns = 0;
            if (
              (registrationType.RegistrationType === "DragonFish" ||
                registrationType === "DragonFish") &&
              inputData.data.sSourceofFish === "2"
            )
            {
              columns = 3;
            }
            else if(registrationType === "Bird")
            {
              columns = 3;
            }
            else 
            {
              columns = 1;
            }

            // for (let index = 1; index < excelData.length; index++) {
            //   if (excelData[index].length > columns) {
            //     setInvalidFileError(true);

            //     return;
            //   }
            // }

            // for (let index = 1; index < excelData.length; index++) {
            //   for (let column = 0; column < columns; column++) {
            //     if (
            //       excelData[index][column] === "" ||
            //       excelData[index][column] === undefined
            //     ) {
            //       setInvalidFileError(true);

            //       return;
            //     }
            //   }
            // }
          }
          if (
            registrationType.RegistrationType === "DragonFish" ||
            registrationType === "DragonFish"
          ) {
            registrationType = "DragonFish";
            for (let index = 1; index < excelData.length; index++) {
              let varietyOfFish = 0;
              let lengthOfFish = 0;
              if (inputData.data.sSourceofFish === "2") {
                if (excelData[index][1].toString() != undefined) {
                  var v = varietyOfFishArray.find(
                    (item) => item.text === excelData[index][1].toString()
                  );
                  if (v) {
                    varietyOfFish = v.id;
                  }
                }

                if (excelData[index][2].toString() != undefined) {
                  var l = lengthOfFishArray.find(
                    (item) => item.text === excelData[index][2].toString()
                  );
                  if (l) {
                    lengthOfFish = l.id;
                  }
                }
              }
              const bulkRequestData: IBulkRegRequest = {
                regName: inputData.data.regName,
                mode: 2,
                userInformation: {
                  name: user?.name,
                  idType: user?.idType,
                  idNo: user?.idNo,
                  email: user?.email,
                  contactNo: user?.contactNo,
                  companyName: user?.companyName,
                  uen: user?.uen,
                  registeredAddress: user?.registeredAddresses?.[0],
                },
                personalInformation: {
                  salutation: inputData.data.ssalutation,
                  name: inputData.data.sapplicantName,
                  uen: inputData.data.sUEN,
                  nric: inputData.data.sNRIC,
                  companyName: inputData.data.scompanyName,
                  organizationAddress: inputData.data.sorganizationAddress,
                  typeofPremises: inputData.data.sorganizationAddress2,
                  blockHouseNumber: inputData.data.sorganizationAddress3,
                  houseNumber: inputData.data.sorganizationAddress4,
                  streetName: inputData.data.sorganizationAddress5,
                  floorNumber: inputData.data.sorganizationAddress6,
                  unitNumber: inputData.data.sorganizationAddress7,
                  buildingName: inputData.data.sorganizationAddress8,
                  postalCode: inputData.data.sorganizationAddress9,
                  country: inputData.data.sorganizationAddress10,
                  mobileNo: inputData.data.smobileNo,
                  email: inputData.data.semail,
                  mobileNoCode: inputData.data.smobilecode,
                  licenceNumber: inputData.data.slicenceNumber,
                  premiseCode: inputData.data.premiseCode,
                },
                applicationInformation: {
                  sourceofFish: inputData.data.sSourceofFish,
                  fcRegistrationNo: inputData.data.sfcRegistrationNo,
                  countryOrigin: inputData.data.scountryOrigin,
                  scientificName: inputData.data.sscientificNameString,
                  citesAppendixNo: inputData.data.scitesAppendixNo,
                  foreignCITESPermitNo: inputData.data.sforeignCITESPermitNo,
                  farmCode: "",
                  legRingNo: "",
                  TypeofTag: 0,
                  TagNumber: "",
                  VarietyofFish:
                    inputData.data.sSourceofFish === "1"
                      ? inputData.data.sVarietyofFish
                      : varietyOfFish,
                  LengthofFish:
                    inputData.data.sSourceofFish === "1"
                      ? inputData.data.sLengthofFish
                      : lengthOfFish,
                  BatchNumber: inputData.data.sBatchNumber,
                  RegisteredQuantityinBatch:
                    inputData.data.sRegisteredQuantityinBatch,
                  HarvestDate: fixTimezoneOffset(inputData.data.sHarvestDate),
                  HatchDate: fixTimezoneOffset(inputData.data.hatchDate),
                  ParentMicrochip: inputData.data.sParentMicrochip,
                  Remarks: inputData.data.sRemarks,
                  MicrochipNumber: excelData[index][0].toString(),
                  expiryDate: fixTimezoneOffset(
                    new Date(inputData.data.expiryDate)
                  ),
                  // registrationMode: "2",
                },
                registrationType: 3,
                uploadedDocument: uploadedDocument,
              };
              fileBulkRegRequests.push(bulkRequestData);
            }
          } else if (
            registrationType.RegistrationType === "Crocodile" ||
            registrationType === "Crocodile"
          ) {
            registrationType = "Crocodile";
            for (let index = 1; index < excelData.length; index++) {
              const bulkRequestData: IBulkRegRequest = {
                regName: bulkRequestedData.regName,
                mode: 2,
                userInformation: {
                  name: user?.name,
                  idType: user?.idType,
                  idNo: user?.idNo,
                  email: user?.email,
                  contactNo: user?.contactNo,
                  companyName: user?.companyName,
                  uen: user?.uen,
                  registeredAddress: user?.registeredAddresses?.[0],
                },
                personalInformation: {
                  salutation: inputData.data.ssalutation,
                  name: inputData.data.sapplicantName,
                  uen: inputData.data.sUEN,
                  nric: inputData.data.sNRIC,
                  companyName: inputData.data.companyName,
                  organizationAddress: inputData.data.sorganizationAddress,
                  typeofPremises: inputData.data.sorganizationAddress2,
                  blockHouseNumber: inputData.data.sorganizationAddress3,
                  houseNumber: inputData.data.sorganizationAddress4,
                  streetName: inputData.data.sorganizationAddress5,
                  floorNumber: inputData.data.sorganizationAddress6,
                  unitNumber: inputData.data.sorganizationAddress7,
                  buildingName: inputData.data.sorganizationAddress8,
                  postalCode: inputData.data.sorganizationAddress9,
                  country: inputData.data.sorganizationAddress10,
                  mobileNo: inputData.data.smobileNo,
                  email: inputData.data.semail,
                  mobileNoCode: inputData.data.smobilecode,
                  licenceNumber: "",
                  premiseCode: inputData.data.premiseCode,
                },
                applicationInformation: {
                  fcRegistrationNo: "",
                  countryOrigin: inputData.data.scountryOrigin,
                  scientificName: inputData.data.sscientificNameString,
                  citesAppendixNo: inputData.data.scitesAppendixNo,
                  foreignCITESPermitNo: inputData.data.sforeignCITESPermitNo,
                  farmCode: "",
                  legRingNo: "",
                  TypeofTag: inputData.data.sTypeofTag,
                  TagNumber: excelData[index][0].toString(),
                  VarietyofFish: 0,
                  LengthofFish: 0,
                  BatchNumber: "",
                  RegisteredQuantityinBatch: 0,
                  HarvestDate: null,
                  HatchDate: null,
                  ParentMicrochip: "",
                  Remarks: "",
                  MicrochipNumber: "",
                  sourceofFish: "",
                  expiryDate: null,
                  // registrationMode: "2",
                },
                registrationType: 2,
                uploadedDocument: uploadedDocument,
              };
              fileBulkRegRequests.push(bulkRequestData);
            }
          } else {
            registrationType = "Bird";
            for (let index = 1; index < excelData.length; index++) {
              const bulkRequestData: IBulkRegRequest = {
                regName: bulkRequestedData.regName,
                mode: 2,
                userInformation: {
                  name: user?.name,
                  idType: user?.idType,
                  idNo: user?.idNo,
                  email: user?.email,
                  contactNo: user?.contactNo,
                  companyName: user?.companyName,
                  uen: user?.uen,
                  registeredAddress: user?.registeredAddresses?.[0],
                },
                personalInformation: {
                  salutation: inputData.data.ssalutation,
                  name: inputData.data.sapplicantName,
                  uen: inputData.data.sUEN,
                  nric: inputData.data.sNRIC,
                  companyName: inputData.data.companyName,
                  organizationAddress: inputData.data.sorganizationAddress,
                  typeofPremises: inputData.data.sorganizationAddress2,
                  blockHouseNumber: inputData.data.sorganizationAddress3,
                  houseNumber: inputData.data.sorganizationAddress4,
                  streetName: inputData.data.sorganizationAddress5,
                  floorNumber: inputData.data.sorganizationAddress6,
                  unitNumber: inputData.data.sorganizationAddress7,
                  buildingName: inputData.data.sorganizationAddress8,
                  postalCode: inputData.data.sorganizationAddress9,
                  country: inputData.data.sorganizationAddress10,
                  mobileNo: inputData.data.smobileNo,
                  email: inputData.data.semail,
                  mobileNoCode: inputData.data.smobilecode,
                  licenceNumber: "",
                  premiseCode: inputData.data.premiseCode,
                },
                applicationInformation: {
                  fcRegistrationNo: inputData.data.sfcRegistrationNo,
                  countryOrigin: inputData.data.scountryOrigin,
                  scientificName: inputData.data.sscientificNameString,
                  citesAppendixNo: inputData.data.scitesAppendixNo,
                  foreignCITESPermitNo: inputData.data.sforeignCITESPermitNo,
                  farmCode: inputData.data.sbulkFarmCode,
                  legRingNo: excelData[index][0].toString(),
                  TypeofTag: 0,
                  TagNumber: "",
                  VarietyofFish: 0,
                  LengthofFish: 0,
                  BatchNumber: "",
                  RegisteredQuantityinBatch: 0,
                  HarvestDate: null,
                  HatchDate: fixTimezoneOffset(inputData.data.hatchDate),
                  ParentMicrochip: "",
                  Remarks: "",
                  MicrochipNumber: "",
                  sourceofFish: "",
                  expiryDate: null,
                  // registrationMode: "2",
                },
                registrationType: 1,
                uploadedDocument: uploadedDocument,
              };
              fileBulkRegRequests.push(bulkRequestData);
            }
          }

          handleFileProcessed(fileBulkRegRequests);
        }
      };

      reader.readAsArrayBuffer(uploadedFile.file);
    });

    // Perform necessary actions with the bulkRegRequests array
  };

  if (selectedFile) {
    return (
      <FilePreview
        selectedFile={selectedFile}
        excelData={excelData}
        onFileSelect={() => setSelectedFile(null)}
        RegistrationType={registrationType}
        columnsToExtract={columnsToExtract}
        bulkRequestedData={bulkRequestedData}
      />
    );
  }

  return (
    <>
      {/* <Header /> */}
      {/* <Container> */}
      <div className="inner-content">
        <div className="container">
          <div className="landing-page form-upload">
            <p>Form Uploaded</p>
            <div className="landing-list">
              {registrationType.RegistrationType === "Bird" ||
                (registrationType === "Bird" && (
                  <h3>
                    LIST OF RING NUMBERS FOR EXPORT/RE-EXPORT OF CAPTIVE-BRED
                    BIRDS
                  </h3>
                ))}
              {registrationType.RegistrationType === "Crocodile" ||
                (registrationType === "Crocodile" && (
                  <h3>
                    LIST OF TAG NUMBERS FOR EXPORT/RE-EXPORT OF CAPTIVE-BRED
                    CROCODILE SKIN
                  </h3>
                ))}
              {registrationType.RegistrationType === "DragonFish" ||
                (registrationType === "DragonFish" && (
                  <h3>
                    LIST OF MICROCHIP NUMBERS FOR EXPORT/RE-EXPORT OF
                    CAPTIVE-BRED DRAGON FISH
                  </h3>
                ))}
              <div className="table-responsive mt-4 mb-2">
                <table className="table table-striped product_table start_table">
                  <thead>
                    <tr>
                      <th>Document Name</th>
                      <th>Date Uploaded</th>
                      <th>Preview List</th>
                    </tr>
                  </thead>
                  <tbody>
                    {uploadedFiles.map((file, index) => (
                      <tr key={index}>
                        <td>
                          <img src={ExecelImg} alt="" className="img-fluid" />{" "}
                          {file.name}
                        </td>
                        <td>{file.date}</td>
                        <td>
                          <img
                            src={PreviewImg}
                            alt=""
                            className="img-fluid"
                            onClick={() => handleFileSelect(file)}
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
            {uploadFileError && (
              <div className="error-message  mb-3">
                Kindly re-upload the filled-up form
              </div>
            )}
            {invalidFileError && (
              <div className="error-message  mb-3">
                Invalid data in the file. Kindly re-upload.
              </div>
            )}
            <button
              type="button"
              className="btn btn-success mt-4"
              onClick={handleFormSubmit}
              disabled={disableSubmit}
            >
              Submit Form
            </button>
          </div>
          {errorMessage && <p className="error-message">{errorMessage}</p>}
          {isSubmiting && <Loader />}
        </div>
      </div>
      {/* </Container>
      <Footer /> */}
    </>
  );
};

export default UploadFileList;
